/**
 * Feature flags configuration
 * Each feature can be enabled for specific publication IDs or globally
 */
const FEATURE_FLAGS = {
  STREAK_COUNTER: {
    enabled: true, // Global enable/disable
    publicationIds: ["jUwsvwnT8CJXRz9CkYoFJt"], // List of publication IDs that have this feature enabled
  },
};

/**
 * Check if a feature is enabled for a given publication ID and embedded status
 * @param {string} featureName - The name of the feature to check
 * @param {string} publicationId - The publication ID to check against
 * @param {boolean} isEmbedded - Whether the feature is being checked in embedded mode
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (
  featureName,
  publicationId,
  isEmbedded = false
) => {
  // If not embedded, always return true
  if (!isEmbedded) {
    return true;
  }

  const feature = FEATURE_FLAGS[featureName];

  if (!feature) {
    console.warn(`Feature flag ${featureName} not found`);
    return false;
  }

  // If feature is globally enabled, return true
  if (feature.enabled) {
    return true;
  }

  // If no publication IDs specified, feature is enabled for all
  if (!feature.publicationIds || feature.publicationIds.length === 0) {
    return true;
  }

  // Check if the publication ID is in the allowed list
  return feature.publicationIds.includes(publicationId);
};
